"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createFetchOptions_1 = require("./createFetchOptions");
var fetchWithRetry_1 = require("./fetchWithRetry");
var getGuid_1 = require("./getGuid");
var getWindowLocationOrigin_1 = require("./getWindowLocationOrigin");
var getRequestNumber_1 = require("./getRequestNumber");
var config_1 = require("./config");
var correlationVector_1 = require("./correlationVector");
var anchormailbox_1 = require("./anchormailbox");
var canary_1 = require("./canary");
var MAX_HTTP_HEADER_LENGTH = 2048;
function makeServiceRequest(actionName, parameters, options) {
    var config = config_1.getConfig();
    var fetchOptions = createFetchOptions_1.default(options);
    var proxyPath = config_1.actionProxyPath(actionName);
    var useOwsProxy = proxyPath != null
        && config.isFeatureEnabled('fwk-proxyActionsToOwsGateway')
        && config.getAuthTokenAsync != null;
    var baseActionUrl = useOwsProxy
        ? config.primeUrl ? config.primeUrl + "/" + proxyPath + "/service.svc?action=" : "/ows/messaging/service.svc?action="
        : config.baseUrl ? config.baseUrl + "/service.svc?action=" : "/owa/service.svc?action=";
    if (config.isUserIdle !== undefined && config.isUserIdle()) {
        fetchOptions.isUserActivity = false;
    }
    var headers = fetchOptions.headers;
    headers.append("Content-Type", "application/json; charset=utf-8");
    headers.append("Action", actionName);
    // The following headers show up on requests made through the existing action framework, but they appear to be for
    // diagnostics or otherwise unnecessary.  Eventually we should figure out whether we want (or need) to include them.
    //
    // Origin
    // X-OWA-ActionId
    // X-OWA-ActionName
    // X-OWA-ActionSource
    // X-OWA-Attempt
    // X-OWA-ClientBegin
    // X-OWA-ClientBuildVersion
    // X-OWA-CorrelationId
    // X-OWA-OfflineRejectCode
    // X-Requested-With
    // Add CorrelationId in header, so the FrontEnd-Begin and FrontEnd-End could be stamped in FE server.
    headers.set('X-OWA-CorrelationId', getGuid_1.default());
    var url = baseActionUrl + actionName;
    if (fetchOptions.isUserActivity !== undefined && fetchOptions.isUserActivity == false) {
        url += "&UA=0";
    }
    url += "&n=" + getRequestNumber_1.default();
    var serializedRequestBody = JSON.stringify(parameters);
    var urlEncodedSerializedRequestBody = encodeURIComponent(serializedRequestBody);
    // Check whether to send the payload on the body or on the header
    if (fetchOptions.noEmptyPost || urlEncodedSerializedRequestBody.length > MAX_HTTP_HEADER_LENGTH) {
        fetchOptions.body = serializedRequestBody;
    }
    else {
        // Add empty post marker for logs.
        url += "&EP=1";
        headers.append("X-OWA-UrlPostData", urlEncodedSerializedRequestBody);
        fetchOptions.body = null;
    }
    if (!headers.has(correlationVector_1.correlationVectorHeaderName)) {
        var cv = correlationVector_1.getCorrelationVector();
        // the cv can be falsy if it gets corrupted, in that case there is no point in sending it
        if (cv) {
            headers.append(correlationVector_1.correlationVectorHeaderName, cv);
        }
    }
    if (config.appName) {
        url += "&app=" + config.appName;
    }
    var currentAttemptCount = 1;
    if (!useOwsProxy) {
        return fetchWithRetry_1.default(actionName, url, currentAttemptCount, fetchOptions);
    }
    else {
        var AnchorMailboxHeader = "X-AnchorMailbox";
        var _a = config.getAuthTokenAsync(getWindowLocationOrigin_1.default()), token = _a[0], tokenPromise = _a[1];
        if (!headers.has(AnchorMailboxHeader)) {
            var anchorMailbox = anchormailbox_1.getAnchorMailboxHeader();
            anchorMailbox && headers.append(AnchorMailboxHeader, anchorMailbox);
        }
        if (token) {
            headers.append("Authorization", "Bearer " + token);
            return fetchWithRetry_1.default(actionName, url, currentAttemptCount, fetchOptions);
        }
        else {
            return tokenPromise
                .then(function (asyncToken) {
                headers.append("Authorization", "Bearer " + asyncToken);
                return fetchWithRetry_1.default(actionName, url, currentAttemptCount, fetchOptions);
            });
        }
    }
}
exports.makeServiceRequest = makeServiceRequest;
function getActionUrl(actionName, urlParameters) {
    var paramString = "";
    if (urlParameters) {
        paramString = "";
        Object.keys(urlParameters).map(function (param) {
            paramString += param + "=" + urlParameters[param] + "&";
        });
    }
    return "service.svc/s/" + actionName + "?" + paramString + "X-OWA-CANARY=" + canary_1.getOwaCanaryCookie();
}
exports.getActionUrl = getActionUrl;
